import { TreeNodeTotals } from 'src/app/models/TreeNodeTotals';

export interface TreeNodeData<T = any> {
  entity: T;
  label: string;
  type: TreeNodeType;
  totals: TreeNodeTotals;
  notes: string;
  startDate: Date;
  endDate: Date;
  lowestLevel: boolean;
}

export enum TreeNodeType {
  Project = 'project',
  Level1 = 'level1',
  Level2 = 'level2',
  Department = 'department',
  Category = 'category',
  GenericTime = 'genericTime',
  GenericExpense = 'genericExpense',
  GenericInternalFee = 'genericInternalFees',
}

export enum OverBudgetError {
  None = 0,
  HourlyBudget = 1 << 0,
  CostFeesBudget = 1 << 1,
  BillableFeesBudget = 1 << 2,
  CostExpenseBudget = 1 << 3,
  BillableExpenseBudget = 1 << 4,
  InternalResourceBudget = 1 << 5,
  CostInternalFeesBudget = 1 << 6,
  BillableInternalFeesBudget = 1 << 7,
}
